/* eslint-disable react/prefer-stateless-function */

import { Modal, ModalBody } from '@99designs/common/components/Modal';
import React from 'react';
import InviteDesignerForm from './InviteDesignerForm';

interface InviteDesignerModalProps {
    onClose: () => void;
    isActive: boolean;
}

export default class InviteDesignerModal extends React.Component<InviteDesignerModalProps> {
    handleClose = () => {
        this.props.onClose();
    };

    render() {
        // TODO: pull in Contests data
        const designer = { id: 1827147, displayName: 'foobar' };
        const contests = [
            {
                id: 964117,
                ineligibilityReason: null,
                isEligible: true,
                remainingInvites: 50,
                timeRemaining: '4 days',
                title: 'xyz',
                url: 'https://99designs.com.dockervm/illustrations/contests/xyz-964117',
            },
        ];

        return (
            <Modal
                variations={['wide', 'medium']}
                isConfirmation={false}
                isActive={this.props.isActive}
                onClose={this.props.onClose}
            >
                <ModalBody>
                    <h1 className="success-modal__heading success-modal__heading--with-divider">
                        Invite to Contest
                    </h1>
                    <div className="success-modal__description">
                        <InviteDesignerForm
                            handleSuccess={() => {}}
                            designerId={designer.id}
                            designerName={designer.displayName}
                            contests={contests}
                            inviteDesignerUrl={``}
                            handleCancel={this.handleClose}
                        />
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/InviteDesignerModal.tsx